import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BoxInfoComponent } from './box-info.component';
import { DssTypographyModule } from '@dss/components/typography';
import { DssButtonModule } from '@dss/components/button';
import { DssIconModule } from '@dss/components/icon';

@NgModule({
  declarations: [BoxInfoComponent],
  imports: [
    CommonModule,
    DssTypographyModule,
    DssButtonModule,
    DssIconModule
  ],
  exports:[BoxInfoComponent]
})
export class BoxInfoModule { }
